/* eslint-disable react/prop-types */
import React from 'react';
import Modal from 'react-modal';
import styles from './ErrorModal.module.css';

const ErrorModal = ({ isOpen, message, detail, closeModal }) => {
  return (
    <Modal
      isOpen={Boolean(isOpen)}
      onRequestClose={closeModal}
      className={`modal-content w-100`}
      overlayClassName={'modal-overlay'}
      contentLabel="Cancel Modal"
    >
      <div className="d-flex flex-column">
        <div style={{ display: 'flex' }}>
          <img width={24} height={24} src="cancel-icon.png" alt="Cancel Icon" />
          <div style={{ fontSize: '18px', fontWeight: '600', marginLeft: '8px' }}>
            Ödeme alınamadı!
          </div>
        </div>
        <div className={`${styles.modalDescription} mt-3`}>{message}</div>
        {detail && <div className={`${styles.modalDetail} mt-2`}>{detail}</div>}

        <div className={`${styles.actionsButtons} mt-4`}>
          <button
            className={`${styles.modalDescription} ${styles.cancelBtn} w-100`}
            onClick={closeModal}
          >
            Kapat
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
